// extracted by mini-css-extract-plugin
export default {"unassignTenantContainer":"UnassignTenantModal_unassignTenantContainer__QiRxK","buttonsContainer":"UnassignTenantModal_buttonsContainer__MWzbP"};